import React from 'react';
import styles from './sign-modal.less';
import { SignModalStore } from 'src/signature/stores/sign-modal.store';
import { Icon, Text } from '@servicetitan/design-system';
import { signatureContainer } from 'src/signature/ioc';
import { observer } from 'mobx-react';
import classNames from 'classnames';

interface SignatureImageProps {
    isCanvasEmpty: boolean;
    setIsCanvasEmpty: (isCanvasEmpty: boolean) => void;
    bindCanvas: (el: HTMLCanvasElement | null) => void;
    unbindCanvas: () => void;
    clearCanvas: () => void;
}

export const SignatureImage: React.FC<SignatureImageProps> = observer(
    ({ isCanvasEmpty, setIsCanvasEmpty, bindCanvas, unbindCanvas, clearCanvas }) => {
        const { isLoading } = signatureContainer.get(SignModalStore)!;

        const canvasRef = React.useRef<HTMLCanvasElement>(null);

        React.useEffect(() => {
            bindCanvas(canvasRef.current);

            return () => unbindCanvas();
            // tslint:disable-next-line: align
        }, [canvasRef]);

        const handleTouchStart = () => setIsCanvasEmpty(false);
        const handleClickIcon = () => {
            setIsCanvasEmpty(true);
            clearCanvas();
        };

        return (
            <div className={styles.signatureImageWrapper}>
                <div className={styles.canvasWrapper}>
                    {!isCanvasEmpty && !isLoading && (
                        <Icon
                            name="backspace"
                            color="#E63717"
                            size={32}
                            className={classNames(styles.backspaceIcon, 'cursor-pointer')}
                            onClick={handleClickIcon}
                        />
                    )}
                    <canvas
                        ref={canvasRef}
                        className={classNames(styles.canvas, {
                            [styles.canvasEmpty]: isCanvasEmpty,
                        })}
                        onTouchStart={handleTouchStart}
                        onMouseDown={handleTouchStart}
                    />
                </div>
                {isCanvasEmpty && <Text className={styles.placeholder}>Sign Here</Text>}
            </div>
        );
    }
);
